export const GET_STATISTICS_MOST_BOUGHT_PLAYERS = "GET_STATISTICS_MOST_BOUGHT_PLAYERS";
export const CLEAR_FILTERS_MOST_BOUGHT_PLAYERS = "CLEAR_FILTERS_MOST_BOUGHT_PLAYERS";